import { Card, CardHeader, Divider, Skeleton, Text } from '@/design-system/components/ui';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/design-system/components/ui/table';

interface Props {
  cardHeader?: string;
  tableHeaders: string[];
  rows?: number;
}

export default function SkeletonTable({ cardHeader, tableHeaders, rows = 3 }: Props) {
  const renderSkeletonRows = (rowCount: number) => {
    const rows = [];

    for (let i = 0; i < rowCount; i++) {
      rows.push(
        <TableRow key={i}>
          {tableHeaders.map((_, index) => (
            <TableCell key={index}>
              <Skeleton variant="text" />
            </TableCell>
          ))}
        </TableRow>,
      );
    }

    return rows;
  };

  return (
    <Card>
      {cardHeader && cardHeader != '' && (
        <>
          <CardHeader>
            <Text variant="body-lg" weight="medium">
              {cardHeader}
            </Text>
          </CardHeader>
          <Divider />
        </>
      )}
      <Table>
        <TableHeader>
          <TableRow>
            {tableHeaders.map((header, index) => (
              <TableHead key={index}>{header}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>{renderSkeletonRows(rows)}</TableBody>
      </Table>
    </Card>
  );
}
